module.exports = __webpack_public_path__ + "img/logo-linkedin.37857a86.svg";